import { useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import axios from 'axios';
import LightAdmin from 'components/headers/lightAdmin';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";

const DashbordAdmin = () => {
    const [orders, setOrders] = useState([]);
    const [orderStats, setOrderStats] = useState({
        total: 0,
        pending: 0,
        completed: 0,
        delivered: 0,
        cancelled: 0,
        refunded: 0,
        pendingPayment: 0,
        totalRevenue: 0,
    });
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        checkAdminStatus();
    }, []);

    const checkAdminStatus = () => {
        const isAdmin = localStorage.getItem('isAdmin') === '1';
        setIsAdmin(isAdmin);

        if (isAdmin) {
            fetchAllOrders();
        } else {
            console.error('Unauthorized: User is not an admin');
        }
    };

    const fetchAllOrders = async () => {
        try {
            const token = localStorage.getItem('authToken');
            console.log(token);
            if (!token) {
                console.error('JWT token not found in local storage');
                return;
            }

            const response = await axios.get('https://hbmdijital.online/api/admin/ordersDashbord', {
                headers: {
                    'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,  // Ensure the token is being sent correctly
                },
            });

            if (response.status === 200) {
                const or = response.data;

                setOrders(or);
                calculateOrderStats(or);
            } else {
                console.error('Failed to fetch orders:', response.statusText);
            }
        } catch (error) {
            console.error('Error fetching orders:', error);
        }
    };

    const calculateOrderStats = (orders) => {
        // Initialize stats object
        const stats = {
            total: 0,
            pending: 0,
            completed: 0,
            delivered: 0,
            cancelled: 0,
            refunded: 0,
            pendingPayment: 0,
            totalRevenue: 0,
        };
    
        // Iterate over the orders to calculate stats
        orders.forEach((order) => {
            stats.total += 1;
    
            // Check the status of the order
            switch (order.status) {
                case 'en attente':
                    stats.pending += 1;
                    break;
                case 'attribué':
                    break; // You can decide if you want to count this for any specific case
                case 'en transit':
                    break; // You can decide if you want to count this for any specific case
                case 'livré':
                    stats.delivered += 1;
                    break;
                case 'annulé':
                    stats.cancelled += 1;
                    break;
                default:
                    break;
            }
    
            // Check the payment status
            if (order.payment.PaymentStatus === 'en attente') {
                stats.pendingPayment += 1;
            }
            if (order.payment.PaymentStatus === 'payé') {
                stats.completed += 1;
            }
    
            // Calculate total revenue (you might want to sum this for each order)
            stats.totalRevenue += parseFloat(order.payment.Amount);
        });
    
        // Set the order stats state
        setOrderStats(stats);
    };
    

    const handleView = (orderID) => {
        console.log(' ');
    };

    const handleEdit = (orderID) => {
        console.log(' ');
    };

    const handleDelete = (orderID) => {
        if (window.confirm(`Are you sure you want to delete order ${orderID}?`)) {
            console.log(' ');
        }
    };

    if (!isAdmin) {
        return <p className="text-danger text-center">Unauthorized: You do not have admin access.</p>;
    }

    return (
        <AnimationRevealPage>
            <LightAdmin />
            <div className="d-flex">
                <section className="w-100 p-3">
                    <div className="d-flex justify-content-start align-items-center gap-2">
                        <h1 className="text-dark display-4">Admin Dashboard</h1>
                    </div>
                    <hr className="my-4" />

                    {/* Order Statistics Cards */}
                    <div className="row">
                    <div className="col-md-4 mb-3">
    <div className="card bg-primary text-white p-3 shadow">
        <div className="card-body">
            <h6 className="card-title">Total des Commandes</h6>
            <p className="card-text fs-3">{orderStats.total}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
    <div className="card bg-warning text-dark p-3 shadow">
        <div className="card-body">
            <h6 className="card-title">Total des Commandes Payées</h6>
            <p className="card-text fs-3">{orderStats.completed}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
    <div className="card bg-success text-white p-3 shadow">
        <div className="card-body">
            <h6 className="card-title">Commandes Livrées</h6>
            <p className="card-text fs-3">{orderStats.delivered}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
    <div className="card bg-danger text-white p-3 shadow">
        <div className="card-body">
            <h6 className="card-title">Commandes Annulées</h6>
            <p className="card-text fs-3">{orderStats.cancelled}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
    <div className="card bg-info text-white p-3 shadow">
        <div className="card-body">
            <h6 className="card-title">Commandes en attente de Livraison</h6>
            <p className="card-text fs-3">{orderStats.pending}</p>
        </div>
    </div>
</div>

<div className="col-md-4 mb-3">
    <div className="card bg-secondary text-white p-3 shadow">
        <div className="card-body">
            <h6 className="card-title">Commandes en attente de Paiement</h6>
            <p className="card-text fs-3">{orderStats.pendingPayment}</p>
        </div>
    </div>
</div>

                    </div>
                </section>
            </div>
            <Footer />
        </AnimationRevealPage>
    );
};

export default DashbordAdmin;
